module.exports = __webpack_public_path__ + "images/633ffe658575d5169bfe70df142e061c.svg";